import React, { useEffect, useState } from "react";
import ProductsBased from "./product/ProductsBased";
import ProductFilter from "./product/ProductFilter";
import { useMetrika } from "../yandex/useMetrika";
import { useLanguage } from '../components/hooks/LanguageContext';
import { fetchProducts } from "../static/js/DataRequestFunctions";

const Products = () => {
    const [products, setProducts] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [selectedSubcategories, setSelectedSubcategories] = useState({});
    const [selectedRegion, setSelectedRegion] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { language } = useLanguage();

    const { reachGoal, hit } = useMetrika();

    useEffect(() => {
        fetchProducts(language)
            .then(data => {
                setProducts(data);
                setLoading(false);
            })
            .catch(error => {
                setError(error.message);
                setLoading(false);
            });

        hit("/products", { title: "Страница продуктов" });
    }, [hit, language]);

    const handleFilterChange = (categories, subcategories, region) => {
        setSelectedCategories(categories);
        setSelectedSubcategories(subcategories);
        setSelectedRegion(region);
        reachGoal("filter_change", { categories, subcategories, region });
    };

    if (loading) {
        return (
            <div className="product-loading-wrapper" style={{ paddingTop: "200px" }}>
                <div className="loading-text">Загрузка продуктов...</div>
                <div className="spinner" />
            </div>
        );
    }

    if (error) {
        return <p style={{ color: "red" }}>Ошибка: {error}</p>;
    }

    const allCategories = Array.from(new Set(products.map(p => p.category)));

    const filteredProductsByRegion = selectedRegion
        ? products.filter(p => p.region.name === selectedRegion)
        : products;

    const categoriesToRender =
        selectedCategories.length > 0 ? selectedCategories : allCategories;

    const preferredOrder = ["AI-решения", "Аналитика конкурентов"];
    const keyProductCategory = "Продукт под ключ";

    const orderedCategories = [
        ...preferredOrder.filter(cat => categoriesToRender.includes(cat)),
        ...categoriesToRender.filter(
            cat => !preferredOrder.includes(cat) && cat !== keyProductCategory
        ),
        ...(categoriesToRender.includes(keyProductCategory)
            ? [keyProductCategory]
            : []),
    ];

    return (
        <>
            <ProductFilter
                products={products}
                selectedCategories={selectedCategories}
                selectedSubcategories={selectedSubcategories}
                selectedRegion={selectedRegion}
                onFilterChange={handleFilterChange}
            />
            {orderedCategories.map(category => (
                <ProductsBased
                    key={category}
                    category={category}
                    subcategory={
                        selectedSubcategories[category]
                            ? selectedSubcategories[category][0]
                            : ""
                    }
                    products={filteredProductsByRegion}
                />
            ))}
        </>
    );
};

Products.link = "/products";

export default Products;
